"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PollingService = void 0;
const constants_1 = require("../../config/constants");
var ERequestServiceStatus;
(function (ERequestServiceStatus) {
    ERequestServiceStatus["PAUSED"] = "PAUSED";
    ERequestServiceStatus["ACTIVE"] = "ACTIVE";
    ERequestServiceStatus["IDLE"] = "IDLE";
})(ERequestServiceStatus || (ERequestServiceStatus = {}));
class PollingService {
    constructor() {
        this.timeout = constants_1.REQUEST_INTERVAL_DEFAULT;
        this.requestsInterval = [];
        this.status = ERequestServiceStatus.IDLE;
        this.methods = [];
    }
    start(methods) {
        if (this.status === ERequestServiceStatus.ACTIVE)
            return;
        [...this.methods, ...methods].forEach(method => {
            var _a;
            //first call
            method.callImmediately && method.callback();
            this.requestsInterval.push(setInterval(() => {
                method.callback();
            }, (_a = method.timeout) !== null && _a !== void 0 ? _a : this.timeout));
        });
        this.methods.push(...methods);
    }
    pause() {
        this.requestsInterval.forEach(interval => {
            clearInterval(interval);
        });
    }
    stop() {
        this.pause();
        this.requestsInterval = [];
    }
}
exports.PollingService = PollingService;
